import { gql } from "graphql-tag";

export const getUserMetadataGQL = gql`
  query GetUserMetadata {
    getUserMetadata {
      onboarding
      hasReceivedWelcomeCoins
      preferredGameCategories
      onboarding
      lastSeenTransactionId
      desiredStreamResolution
    }
  }
`;

export const getUnseenRewardTransactionsGQL = gql`
  query GetUnseenRewardTransactions {
    getUserV2 {
      unseenRewardTransactions {
        amount
        category
        createdAt
        currency
        entryId
        expiryDate
        gameId
        gameTitle
        reference
        runningBalance
        status
        transactionType
        type
        walletType
        workflow
      }
    }
  }
`;

export const searchUserGQL = gql`
  query Users($searchUsersInput: SearchUsersInput!) {
    users(searchUsersInput: $searchUsersInput) {
      totalCount
      items {
        id
        username
        avatar
        xp
        lastCheckin
        followStatus
      }
    }
  }
`;
